import React from 'react';

const Topics = ({ onOpenForm }) => {
  return (
    <section id="temas" className="py-16 bg-primary text-neutral-lightest">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-sans font-bold mb-2">Temas Abordados na Mentoria</h2>
          <div className="w-24 h-1 bg-secondary mx-auto mb-6"></div>
          <p className="text-xl text-neutral-lightest/80 max-w-3xl mx-auto">
            Conheça os principais tópicos que serão explorados durante o programa de mentoria
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          <div className="bg-primary-medium p-6 rounded-lg shadow-medium border border-white/10 hover:border-secondary/30 transition-all duration-300 hover:transform hover:scale-105">
            <div className="w-16 h-16 bg-secondary/20 rounded-full flex items-center justify-center mb-4 mx-auto">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-secondary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
              </svg>
            </div>
            <h3 className="text-xl font-sans font-semibold mb-3 text-center">Lipedema</h3>
            <p className="text-neutral-lightest/80 text-center md:text-left">
              Estudo aprofundado dos mecanismos hormonais e sua influência no metabolismo, composição corporal e saúde geral.
            </p>
          </div>
          
          <div className="bg-primary-medium p-6 rounded-lg shadow-medium border border-white/10 hover:border-secondary/30 transition-all duration-300 hover:transform hover:scale-105">
            <div className="w-16 h-16 bg-secondary/20 rounded-full flex items-center justify-center mb-4 mx-auto">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-secondary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
              </svg>
            </div>
            <h3 className="text-xl font-sans font-semibold mb-3 text-center">Protocolos de Emagrecimento</h3>
            <p className="text-neutral-lightest/80 text-center md:text-left">
              Estratégias personalizadas e baseadas em evidências para promover a perda de peso saudável e sustentável.
            </p>
          </div>
          
          <div className="bg-primary-medium p-6 rounded-lg shadow-medium border border-white/10 hover:border-secondary/30 transition-all duration-300 hover:transform hover:scale-105">
            <div className="w-16 h-16 bg-secondary/20 rounded-full flex items-center justify-center mb-4 mx-auto">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-secondary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
              </svg>
            </div>
            <h3 className="text-xl font-sans font-semibold mb-3 text-center">Reposição Hormonal</h3>
            <p className="text-neutral-lightest/80 text-center md:text-left">
              Técnicas embasadas em fisiologia e nas melhores evidências para diagnóstico e tratamento para desequilíbrios hormonais em diferentes faixas etárias.
            </p>
          </div>
          
          <div className="bg-primary-medium p-6 rounded-lg shadow-medium border border-white/10 hover:border-secondary/30 transition-all duration-300 hover:transform hover:scale-105">
            <div className="w-16 h-16 bg-secondary/20 rounded-full flex items-center justify-center mb-4 mx-auto">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-secondary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z" />
              </svg>
            </div>
            <h3 className="text-xl font-sans font-semibold mb-3 text-center">Implantes Hormonais</h3>
            <p className="text-neutral-lightest/80 text-center md:text-left">
              Domínio completo da técnica de implantes, desde a indicação até a aplicação e acompanhamento dos resultados.
            </p>
          </div>
          
          <div className="bg-primary-medium p-6 rounded-lg shadow-medium border border-white/10 hover:border-secondary/30 transition-all duration-300 hover:transform hover:scale-105">
            <div className="w-16 h-16 bg-secondary/20 rounded-full flex items-center justify-center mb-4 mx-auto">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-secondary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            <h3 className="text-xl font-sans font-semibold mb-3 text-center">Menopausa</h3>
            <p className="text-neutral-lightest/80 text-center md:text-left">
              Análise detalhada de casos reais, com discussão de diagnósticos, condutas e resultados obtidos na prática clínica.
            </p>
          </div>

          <div className="bg-primary-medium p-6 rounded-lg shadow-medium border border-white/10 hover:border-secondary/30 transition-all duration-300 hover:transform hover:scale-105">
            <div className="w-16 h-16 bg-secondary/20 rounded-full flex items-center justify-center mb-4 mx-auto">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-secondary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              </svg>
            </div>
            <h3 className="text-xl font-sans font-semibold mb-3 text-center">Gestão de carreira</h3>
            <p className="text-neutral-lightest/80 text-center md:text-left">
              Ferramentas e estratégias para organização do consultório, planejamento financeiro e fiscal, gestão de pacientes e otimização de custos e resultados clínicos.
            </p>
          </div>
        </div>
        
        <div className="text-center mt-12">
          <a 
            href="https://pt.surveymonkey.com/r/R7CD6CV"
            target="_blank" rel="noopener noreferrer"
            className="inline-block bg-secondary hover:bg-secondary-light text-primary-dark font-bold py-3 px-8 rounded-full text-center transition-colors duration-300 shadow-soft"
          >
            Inscreva-se na Mentoria
          </a>
        </div>
      </div>
    </section>
  );
};

export default Topics;


